module.exports = "/_next/static/files/b526072c5857bcbe8264f06a61da3b77.png";